module.exports = __webpack_public_path__ + "img/fa46c.f4a96623.svg";